import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VideoPlayer from "react-video-js-player";
import Page from "../../finwell/pages/Page";
import { useNavigate } from "react-router-dom";
import _, { unset } from "lodash";
import { useParams } from "react-router-dom";
import {
  getVideoCourseCategories,
  getVideoDetailListing,
  getBrokerVideoListing,
  getBrokerVideoDetail,
  getBrokerVideoListingClear,
  getVideoDetailListingClear,
  getBrokerVideoDetailClear,
  getVideoCompt,
  getVideoCoursesListingRelated,
  getVideoCoursesListingRelatedClear,
} from "../../redux/video/actions";
import Loader from "../../components/Loader/Loader";
import { Spinner } from "react-bootstrap";
import YoutubeEmbed from "./YoutubeEmbed";
import {
  checkRankStatusFunc,
  clickStreamUser,
  convertTimeInHourAndMin,
  formatLPCoursesList,
  getFormatedDataOfLPUtils,
  getPriceInfoForEntity,
  getProcureInfo,
  SessionKeys,
  videoExtensionType,
} from "../../utils/AppUtils";
import AssignCourseModal from "../../components/modal/AssignCourseModal";
import CONFIG from "../../utils/config";
import { setCurrentView } from "../../redux/assignCourse/actions";
import {
  checkContentAccess,
  checkContentAccessClear,
  getActiveHeader,
} from "../../redux/home/actions";
import {
  getCheckListInsert,
  getModuleListingClearBroker,
  getModuleListingClear,
  getSingleLP,
  getSingleLPClear,
  getMyLearningPathsClear,
  getMyLearningPaths,
  getRankStatus,
  getRankStatusClear,
} from "../../redux/courses/actions";
import BackButton from "../../components/Layouts/BackButton";
import { videoEvents } from "../../utils/VideoClickStream";
import VideoContentSection from "../../components/Video/VideoContentSection";
import { VideoCoursesDataSetupSection } from "../../components/Video/VideoCoursesDataSetupSection";
import CongPopupAnimation from "../../components/Course/CongPopupAnimation";
import LPMoreLearn from "../../components/Course/LPMoreLearn";
import BreadCrumbComponent from "../../components/NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import VideoDetailComponent from "../../components/NewDesign/Video/VideoDetail/VideoDetailComponent";
import ShimmerScreen from "../../components/Layouts/ShimmerScreen";
import CartBandComponent from "../../components/NewDesign/DetailPage/CartBand/CartBandComponent";
import DetailPageBannerHeaderComponent from "../../components/NewDesign/DetailPage/DetailPageBannerHeader/DetailPageBannerHeaderComponent";
import useLogin from "../../custom-hooks/useLogin";
import { routeList } from "../../utils/routeList";
import LPdetailComp from "../../components/b2cComponents/LPDetailComp";
import NotFoundImage from "../../components/NewDesign/NotFound/NotFoundImage";
import AfterCongratulationsModal from "../../components/modal/AfterCongratulationsModal";
import { useTranslation } from "react-i18next";
const VideoViewPageSection = (props) => {
  const { isMainPageLoading, setIsMainPageLoading, isMobile } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useLogin();
  const { productId } = useParams();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  // const source = params.get("source");
  // const videoCode = params.get("code");
  // const catId = params.get('catId');
  // const via_lp = params.get('via_lp');
  // const lp_id = params.get('lp_id');
  // const level_id = params.get('level_id');
  // const is_level = params.get('is_level');
  // const is_paid = params.get('is_paid');
  // const lp_source = params.get("lp_source");
  const { t } = useTranslation();
  const c = params.get("c");
  let source = "";
  let videoCode = "";
  let catId = "";
  let via_lp = "";
  let lp_id = "";
  let lp_source = "";
  let level_id = "";
  let is_level = "";
  let is_paid = "";
  let from = "";
  let provider_name = "";
  let provider_id = "";
  let is_home = "";

  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    source = _.toLower(paramsReq.source);
    videoCode = paramsReq.code;
    catId = paramsReq.catId;
    via_lp = paramsReq.via_lp;
    from = paramsReq.from;
    lp_id = paramsReq.lp_id;
    level_id = paramsReq.level_id;
    is_level = paramsReq.is_level;
    is_paid = paramsReq.is_paid;
    lp_source = paramsReq.lp_source;
    provider_name = paramsReq.provider_name;
    provider_id = paramsReq.provider_id;
    is_home = paramsReq?.is_home;
  }

  const authBroker = useSelector((state) => state.auth.authBroker);
  const myLearningPathsData = useSelector(
    (state) => state.courses.myLearningPaths
  );
  const auth = useSelector((state) => state.auth);
  // const [productId] = useState(history.location.state?.productId)
  const videoDetailListingData = useSelector(
    (state) => state.video?.videoDetail
  );
  const userRole = useSelector((state) => state.user.role);
  const videoDetailListingDataBroker = useSelector(
    (state) => state.video?.videoDetailBrAdmin
  );
  const checkContent = useSelector((state) => state.home.checkContent);
  const videoListingDataRelatedRes = useSelector(
    (state) => state.video.videoCoursesListingRelated
  );
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const lpData = useSelector((state) => state.courses.lpData);
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const rankStatusRes = useSelector((state) => state.courses.rankStatusRes);
  const [hasTeaser, setHasTeaser] = useState(false);
  // const authBroker = useSelector(state => state.auth.authBroker)
  const [videoDetailInfo, setVideoDetailInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [videoLoading, setVideoLoading] = useState(true);
  const [imgLoader, setImgLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showAssignBtn, setShowAssignBtn] = useState(true);
  const [showContent, setShowContent] = useState(true);
  const [showLearnMore, setShowLearnMore] = useState(false);
  const [isLPCompleted, setIsLPCompleted] = useState(false);
  const [showLPLearnMore, setShowLPLearnMore] = useState(false);
  const [relatedVideoList, setRelatedVideoList] = useState([]);
  const [isYoutube, setIsYoutube] = useState(false);
  const [youtubePlayer, setYoutubePlayer] = useState("");

  const [isShowCongrat, setIsShowCongrat] = useState(false);
  const [isAnimCompleted, setIsAnimCompleted] = useState(false);

  const [singleLpData, setSingleLpData] = useState({});
  const [showNextCourse, setShowNextCourse] = useState(false);
  const [isLastRecord, setIsLastRecord] = useState(true);

  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: provider_id ? "Partners" : is_home ? "Home" : t("learn"),
      active: false,
      link: "",
      isLoading: false,
    },
    { name: t("videos"), active: false, link: "", isLoading: false },
    { name: "-", active: false, link: "", isLoading: true },
  ]);
  const [videoInfo, setVideoInfo] = useState({});
  const [headerProdData, setHeaderProdData] = useState({});
  const textAreaRef = useRef(null);

  const [learningPathData, setLearningPathData] = useState({});
  const [showShimmer, setShowShimmer] = useState(false);
  const [showRankUp, setShowRankUp] = useState(false);
  const [newRank, setNewRank] = useState("");

  const [isGuest, setIsGuest] = useState(false);
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.payload.user.role.includes("guest")) {
        setIsGuest(true);
      }
    }
  }, [authBroker]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      if (_.isEmpty(provider_name)) {
        dispatch(getActiveHeader("learn"));
      }
    }, 1000);

    return () => {
      setShowLearnMore(false);
      setIsLPCompleted(false);
    };
    //getSingleLPData();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(addToCartRes)) {
      if (!isLoggedIn) {
        if (addToCartRes.status === "success") {
          console.log("ADD TO CART", addToCartRes);
          const payload = addToCartRes.payload?.payload;
          if (!_.isEmpty(payload) && payload.user_id) {
            localStorage.setItem(SessionKeys.SESSION_ID, payload.user_id);
          }
          let postData = {
            video_id: _.toNumber(productId),
            email: authBroker?.payload?.user?.email
              ? authBroker?.payload?.user?.email
              : localStorage?.getItem(SessionKeys.USERNAME),
            user_id: localStorage?.getItem(SessionKeys.USER_ID),
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            session_id: isLoggedIn
              ? localStorage.getItem(SessionKeys.SESSION_ID)
              : "",
            language: activeLanguage ? activeLanguage : "",
          };
          if (from === "lp") {
            postData.lp_id = _.toNumber(lp_id);
          } else if (from === "bundle") {
            postData.bundle_id = _.toNumber(lp_id);
          }
          dispatch(
            getVideoDetailListing({
              module: "videoDetailEcom",
              postData,
            })
          );
        }
      }
    }
  }, [addToCartRes, activeLanguage]);

  useEffect(() => {
    dispatch(getModuleListingClearBroker());
    dispatch(getModuleListingClear());
    // dispatch(checkContentAccess({
    // 	module: 'checkContentAccess',
    // 	postData: {
    // 		token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    // 		origin: source === 'xsel' ? 'xsel' : 'broker',
    // 		entity_id: source === 'xsel' ? videoCode : productId,
    // 		entity_type: 'videos'
    // 	}
    // }))
    if (catId) {
      // dispatch(getVideoCoursesListingRelated({
      //     module: "getVideoCourseListingRelated",
      //     postData: {
      //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //         category_id: catId
      //     }
      // }))
    }
  }, [dispatch, catId]);

  useEffect(() => {
    if (!_.isEmpty(rankStatusRes)) {
      if (rankStatusRes?.status === "success") {
        let data = rankStatusRes?.payload?.payload;
        if (data.rank_increase) {
          setNewRank(data.rank);
          localStorage.setItem(SessionKeys.CURRENT_RANK, data.rank);
          setShowRankUp(true);
          dispatch(getRankStatusClear({}));
        } else {
          setShowRankUp(false);
        }
      }
    }
  }, [rankStatusRes]);

  // useEffect(() => {
  //   if(via_lp === "true"){
  //       getSingleLPData();
  //     }
  // }, [via_lp])

  useEffect(() => {
    if (isShowCongrat) {
      setTimeout(() => {
        if (via_lp === "true") {
          getSingleLPData();
        }
        // alert(isLPCompleted)
        // setShowLearnMore(isLPCompleted ? true : false)
      }, 2000);
    }

    if (isAnimCompleted) {
      console.log("Anim is completed");
      if (userRole !== "manager" && !isGuest) {
        checkRankStatusFunc(dispatch, getRankStatus);
      }
      return () => {
        setIsAnimCompleted(false);
      };
    }
  }, [isShowCongrat, isAnimCompleted]);

  useEffect(() => {
    if (!_.isEmpty(videoListingDataRelatedRes)) {
      let sortedData = [];
      if (videoListingDataRelatedRes.status === "success") {
        sortedData = videoListingDataRelatedRes?.payload?.payload;
        // let sortedData = sortByAlphabetical(arr);
        if (!_.isEmpty(sortedData)) {
          sortedData = VideoCoursesDataSetupSection(sortedData, isPremiumUser);
        }
      }

      let tempArr = [];
      for (const item of sortedData) {
        if (_.toNumber(item.product_id) !== _.toNumber(productId)) {
          tempArr.push(item);
        }
      }
      setRelatedVideoList(tempArr);
      dispatch(getVideoCoursesListingRelatedClear());
    }
  }, [videoListingDataRelatedRes]);

  useEffect(() => {
    if (!_.isEmpty(lpData)) {
      setIsShowCongrat(false);
      if (lpData.status === "success") {
        let learning = _.cloneDeep(lpData.payload.payload);
        if (!_.isEmpty(learning)) {
          setIsShowCongrat(false);
          let sendFlag = false;
          let pushCourse = false;
          let anyLockExists = false;
          let courseToPush = [];
          learning = formatLPCoursesList(learning);
          if (learning.coursesList) {
            for (let course of learning.coursesList) {
              if (course.isLock) {
                anyLockExists = true;
              }
            }
            for (let [index, course] of learning.coursesList.entries()) {
              let currentCourse = course;
              let nextCourse = learning.coursesList[index + 1];
              if (
                !currentCourse?.is_checklist_approved &&
                currentCourse?.is_checklist_present &&
                !sendFlag
              ) {
                if (
                  currentCourse.crs_progress >= 100 &&
                  index !== learning.coursesList.length - 1
                ) {
                  dispatch(
                    getCheckListInsert({
                      module: "checklist-insert",
                      postData: {
                        token: localStorage.getItem(
                          SessionKeys.API_TOKEN_BROKER
                        ),
                        lp_id: learning?.id,
                        entity_id:
                          currentCourse.source === "broker"
                            ? currentCourse.id
                            : currentCourse?.crscd,
                        entity_type: !currentCourse?.is_level
                          ? currentCourse.entity_type
                          : "level",
                      },
                    })
                  );
                  sendFlag = true;
                }
              }
              // if (pushCourse) {
              //   learning.newCourseList.push(course)
              // }
              // if (is_level === 'true') {
              //   if (_.toNumber(course.id) === _.toNumber(level_id)) {
              //     pushCourse = true;
              //   }
              // } else {
              //   if (course.crscd === productId) {
              //     pushCourse = true;
              //   }
              // }
              // if (course.id === productId ||course.id === level_id) {
              //   pushCourse = true
              // }
              if (anyLockExists) {
                if (is_level === "true") {
                  if (course.id === level_id) {
                    if (course.crs_progress < 100) {
                      learning.newCourseList.push(course);
                    }
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course);
                  } else {
                    if (course.crs_progress < 100) {
                      learning.newCourseList.push(course);
                    }
                  }
                } else {
                  if (course.id === productId) {
                    console.log("this is me " + course.name);
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course);
                  } else {
                    if (course.crs_progress < 100) {
                      // learning.newCourseList.push(course)
                      courseToPush.push(course);
                    }
                  }
                }
              } else {
                if (course.crs_progress < 100) {
                  // learning.newCourseList.push(course)
                  courseToPush.push(course);
                }
              }
            }
            for (let course of courseToPush) {
              learning.newCourseList.push(course);
            }
            learning.coursesList = learning.newCourseList;
          }
          if (learning.coursesList.length === 0) {
            setIsLastRecord(true);
            setShowNextCourse(false);
          } else {
            setIsLastRecord(false);
            setShowNextCourse(true);
          }
          console.log("LP DATA", learning, productId);
          if (!_.isEmpty(learning.coursesList)) {
            setShowLearnMore(true);
            setSingleLpData(learning);
          }
        }
      } else {
        setSingleLpData({});
      }
      dispatch(getSingleLPClear());
    }
    // return (() => {
    //   setShowNextCourse(false)
    //   setIsLastRecord(true)
    // })
  }, [lpData]);

  useEffect(() => {
    if (!_.isEmpty(videoDetailInfo)) {
      const videoData = videoDetailInfo[0];
      if (!_.isEmpty(videoData)) {
        console.log("Video INFO", videoData);
        setHasTeaser(videoData.is_teaser);
        setVideoInfo(videoData);
        let breadCData = [
          {
            name: provider_id ? "Partners" : is_home ? "Home" : t("learn"),
            active: false,
            link: isMobile
              ? ""
              : provider_id
              ? "/our-partners"
              : is_home
              ? "/home"
              : routeList.LEARN_LP_PAGE,
            isLoading: false,
          },
        ];
        let paramsReq = {
          provider_id: provider_id,
          provider_name: provider_name,
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        if (provider_name) {
          breadCData.push({
            name: provider_name,
            active: false,
            link: isMobile ? "" : `/partner-detail?c=${encodedUrl}`,
            isLoading: false,
          });
        }
        if (via_lp === "true" || from === "bundle") {
          breadCData.push({
            name: from === "bundle" ? t("combo&Offers") : t("Action Path"),
            active: false,
            link: isMobile
              ? ""
              : from === "bundle"
              ? routeList.LEARN_COMBO_PAGE
              : routeList.LEARN_LP_PAGE,
            isLoading: false,
          });
          breadCData.push({
            name: videoData.lp_name,
            active: false,
            link: isMobile ? "" : -1,
            isLoading: false,
          });
        }
        breadCData.push({
          name: t("videos"),
          active: false,
          link: isMobile
            ? ""
            : provider_id
            ? `/partner-detail/videos/?c=${encodedUrl}`
            : from === "lp" || from === "bundle"
            ? -1
            : routeList.LEARN_VIDEOS_PAGE,
          isLoading: false,
        });
        breadCData.push({
          name: videoData.product_name,
          active: true,
          link: "",
          isLoading: false,
        });
        setBreadCrumbData(breadCData);
        let tags = [];
        let logoURL = "";
        if (!_.isEmpty(videoData.provider)) {
          tags.push(videoData.provider.provider_display_name);
          logoURL = videoData.provider.provider_img;
        }
        tags.push("Video");
        tags.push(`${videoData.views} View${videoData.views > 1 ? "s" : ""}`);
        /**
         * format for priceInfo
         * priceInfo = {
         *  isFree: boolean,
         *  isPaid: boolean,
         *  isAddToCart: boolean,
         *  price: int
         * }
         */
        // let priceInfo = getPriceInfoForEntity({
        //     isUserPremiun: isPremiumUser,
        //     productType: videoData.sfdc_product_type.toLowerCase(),
        //     premiumPrice: videoData.product_premium_price,
        //     basicPrice: videoData.product_sale_price,
        //     offerPremiumPrice: videoData.product_offer_for_premium,
        //     offerBasicPrice: videoData.product_offer_for_basic,
        //     offerStartDate: '', //videoData.start_date_&_time_of_offer,
        //     offerEndDate: '', //videoData.end_date_&_time_of_offer,
        //     source: videoData.source,
        //     productIsPaid: videoData.is_paid,
        //     inAddToCart: videoData.is_addtocart
        // })
        let priceInfo = getProcureInfo(videoData.purchased_info);
        priceInfo.isAddToCart = videoData.is_addtocart;
        console.log("PRICE INFO", priceInfo);
        if (!isLoggedIn) priceInfo.isFree = false;
        setHeaderProdData({
          id: videoData.product_id,
          title: videoData.product_name,
          logoURL: logoURL,
          logoAltText: "VD",
          bannerURL: videoData.product_thumbnail,
          tagsArray: tags,
          description: videoData.product_description,
          duration: convertTimeInHourAndMin(videoData.course_duration),
          view: videoData.views,
          price: priceInfo.price,
          isPaid: priceInfo.isPurchased,
          priceInfo: priceInfo,
          purchaseInfo: videoData.purchased_info,
          teaserURL: !_.isEmpty(videoData.teaser)
            ? videoData?.teaser?.teaser_video_link
            : "",
          teaserType: !_.isEmpty(videoData.teaser)
            ? videoData?.teaser?.teaser_video_url
            : "",
          provider: videoData?.provider,
          priceText: `Price:  ${videoData?.purchased_info?.currency_symbol}${videoData?.purchased_info?.selling_price} `,
        });
      } else {
        setVideoInfo({});
      }
    } else {
      setVideoInfo({});
    }
  }, [videoDetailInfo]);

  const getSingleLPData = () => {
    console.log("call single LP Data");
    setShowShimmer(true);
    if (lp_source === "xsel" || source === "ecom") {
      dispatch(
        getMyLearningPaths({
          module: "getMyLearningPathsEcom",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            is_onboarding: 0,
            id: lp_id,
          },
        })
      );
    } else {
      dispatch(
        getMyLearningPaths({
          module: "getMyLearningPaths",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            assigned: 0,
            lp_id: lp_id,
            language: activeLanguage ? activeLanguage : "",
          },
        })
      );
    }

    // dispatch(getSingleLP({
    //     module: 'singleLPInfo',
    //     postData: {
    //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //         lp_id: lp_id
    //     }
    // }))
  };

  useEffect(() => {
    // console.log('LearningPath', myLearningPathsData)
    // alert(JSON.stringify(myLearningPathsData))
    if (!_.isEmpty(myLearningPathsData)) {
      if (myLearningPathsData.status === "success") {
        setIsLoading(false);
        setShowShimmer(false);
        if (!_.isEmpty(myLearningPathsData.payload.payload)) {
          let learning = _.cloneDeep(myLearningPathsData.payload.payload);
          let learningData = getFormatedDataOfLPUtils(learning, dispatch);
          // learningPathData?.coursesList
          let contentArr = [];
          let learningTemp = _.cloneDeep(learningData);
          for (const iterator of learningData?.coursesList) {
            if (iterator.crs_progress < 100) {
              contentArr.push(iterator);
            }
          }

          for (const record of contentArr) {
            let checklistArray = [];
            record.clInfo = {};
            if (
              record.is_checklist_present &&
              !_.isEmpty(record.checklist_data) &&
              !_.isEmpty(record.checklist_data.checklist_title)
            ) {
              // alert(JSON.stringify(record.checklist_data.checklist_title))
              checklistArray = record.checklist_data.checklist_title;
              let clData = record.checklist_data;
              record.clInfo = {
                lp_name: clData.prgm_nm,
                course_or_level: clData.type,
                course_name: clData.crs,
                course_completion_date: clData.course_completion_date
                  ? clData.course_completion_date
                  : "",
                rea_name: clData.user_name,
                title_array: checklistArray,
              };
              // if (learning.id == 16548) alert(JSON.stringify(record))
            }
          }

          learningTemp.coursesList = contentArr;
          if (!_.isEmpty(contentArr)) {
            setShowLearnMore(true);
            setIsLPCompleted(false);
            setShowLPLearnMore(true);
          } else {
            setShowLearnMore(false);
            setIsLPCompleted(true);
            setShowLPLearnMore(false);
          }
          setLearningPathData(learningTemp);
        }
      }
      dispatch(getMyLearningPathsClear());
    }
  }, [myLearningPathsData]);

  const onPlayerReady = (player) => {
    setVideoLoading(false);
    console.log("Player is ready: ", player);
    // splayer;
    player.src("");
    // player.crossorigin('use-credentials')
    let videoData = videoDetailInfo[0];
    player.src(videoData.video_link);
    // player.src({
    //     src: 'https://cdn-stg.niit-mts.com/xsel/media/9cbddd10-ee5f-4972-a5da-11dfde71fcff.m3u8',
    //     withCredentials: true
    // })
    const trackEl = player.addRemoteTextTrack(
      {
        src: videoData?.subtitle_url,
        kind: "captions",
        srclang: "en",
        label: "English",
      },
      false
    );
    trackEl.addEventListener("load", function () {
      // your callback goes here
    });
    window.scrollTo(0, 135);
    // if (textAreaRef.current) {
    //   textAreaRef.current.scrollIntoView();
    // }

    videoEvents(player, {
      type: "video",
      video_id: _.toNumber(productId),
      user_id: authBroker?.payload?.user?.user_id,
    });

    player.on("ended", () => {
      videoCompleted();
    });
  };

  useEffect(() => {
    // console.log("PID", productId);
    // console.log("source", source)
    setIsLoading(true);
    setShowLearnMore(false);
    setVideoDetailInfo([]);
    setIsShowCongrat(false);
    setIsAnimCompleted(false);
    const script = document.createElement("script");

    script.src = "https://www.youtube.com/player_api";
    // script.src = "https://www.youtube.com/iframe_api";
    script.async = true;

    document.body.appendChild(script);
    fetchVideoDetail();
    if (showContent && !_.isEmpty(authBroker) && !_.isEmpty(productId)) {
    }
  }, [showContent, authBroker, productId, activeLanguage]);

  useEffect(() => {
    if (!_.isEmpty(videoDetailListingData)) {
      console.log("data---", videoDetailListingData);
      if (videoDetailListingData?.status === "success") {
        const data = videoDetailListingData?.payload?.payload;
        if (
          _.isEmpty(data[0].purchased_info) ||
          data[0].purchased_info.is_purchased ||
          parseInt(data[0].purchased_info.selling_price) === 0
        ) {
          let video_link = data[0].video_link;
          let typeSplit = video_link.includes(".") ? video_link.split(".") : [];
          let extension = typeSplit[typeSplit.length - 1];
          let is_videofile =
            typeSplit.length > 0
              ? ["m3u8", "mp4", "mkv", "webm", "avi"].includes(extension)
              : false;
          data[0].is_videofile = is_videofile;
          data[0].extension = videoExtensionType(extension);
          data[0].is_youtube = false;
          if (data[0].video_link.includes("youtube.com")) {
            data[0].is_youtube = true;
            data[0].is_videofile = true;
            data[0].video_type = "url";
          }
        }
        setVideoDetailInfo(data);

        // setVideoDetailInfo(videoDetailListingData?.payload?.payload);
      }
      setIsLoading(false);
      setIsMainPageLoading(false);
      dispatch(getVideoDetailListingClear());
    }
  }, [videoDetailListingData]);

  useEffect(() => {
    if (!_.isEmpty(videoDetailListingDataBroker)) {
      if (videoDetailListingDataBroker?.status === "success") {
        const data = videoDetailListingDataBroker?.payload?.payload;
        // console.log("VIDEO DATA", data);
        if (!_.isEmpty(data)) {
          let type = data[0].type;
          let video_link = data[0].video_link;
          let typeSplit = video_link.includes(".") ? video_link.split(".") : [];
          let extension = typeSplit[typeSplit.length - 1];
          let is_videofile =
            typeSplit.length > 0
              ? ["m3u8", "mp4", "mkv", "webm", "avi"].includes(extension)
              : false;
          data[0].video_type = type;
          data[0].is_videofile = is_videofile;
          data[0].extension = videoExtensionType(extension);
          data[0].is_youtube = false;
          if (data[0].video_link.includes("youtube.com")) {
            data[0].is_youtube = true;
            data[0].is_videofile = true;
            data[0].video_type = "url";
          }
          setVideoDetailInfo(data);
          console.log("data--", data);
        }
      }
      setIsLoading(false);
      setIsMainPageLoading(false);
      dispatch(getBrokerVideoDetailClear());
    }
  }, [videoDetailListingDataBroker]);

  useEffect(() => {
    if (!_.isEmpty(videoDetailInfo) && _.isArray(videoDetailInfo)) {
      let videoData = videoDetailInfo[0];
      console.log("videodata--", videoData);
      if (
        _.isEmpty(videoData.purchased_info) ||
        videoData.purchased_info.is_purchased ||
        parseInt(videoData.purchased_info.selling_price) === 0
      ) {
        if (!videoData.is_videofile && videoData.is_youtube) {
          dispatch(
            getVideoCompt({
              module: "videoCompletionStatus",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                entity_id: videoData.product_id,
                entity_type: "video",
                status: "completed",
                source: videoData.source === "xsel" ? "xsel" : "brokerage",
                entity_name: videoData?.product_name,
                learning_points: videoData?.learning_points,
              },
            })
          );
        }
        if (videoData.is_youtube) {
          console.log("videoData:", videoData);
          let ytID = videoData?.video_link
            ?.split("https://www.youtube.com/embed")[1]
            ?.split("title")[0]
            ?.replace('" ', "")
            ?.replace("/", "");
          setTimeout(() => floaded(ytID), 2000);
        }
      }
    }
  }, [videoDetailInfo]);

  const fetchVideoDetail = () => {
    if (source === "xsel") {
      let postData = {
        video_id: _.toNumber(productId),
        email: authBroker?.payload?.user?.email
          ? authBroker?.payload?.user?.email
          : localStorage?.getItem(SessionKeys.USERNAME),
        user_id: localStorage?.getItem(SessionKeys.USER_ID),
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        session_id: localStorage.getItem(SessionKeys.SESSION_ID),
        language: activeLanguage ? activeLanguage : "",
      };
      if (from === "lp") {
        postData.lp_id = _.toNumber(lp_id);
      } else if (from === "bundle") {
        postData.bundle_id = _.toNumber(lp_id);
      }
      dispatch(
        getVideoDetailListing({
          module: "videoDetailEcom",
          postData,
        })
      );
    } else {
      let postData = {
        video_id: _.toNumber(productId),
        email: authBroker?.payload?.user?.email
          ? authBroker?.payload?.user?.email
          : localStorage?.getItem(SessionKeys.USERNAME),
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        language: activeLanguage ? activeLanguage : "",
      };
      if (via_lp === "true") {
        postData.lp_id = _.toNumber(lp_id);
      }
      dispatch(
        getBrokerVideoDetail({
          module: "videoDetailBroker",
          postData,
        })
      );
    }
  };

  const floaded = (ytID) => {
    console.log("YOUTUBE ID", ytID);
    try {
      let players = new window.YT.Player("youtube-player", {
        height: "70%",
        width: "100%",
        videoId: ytID,
        playerVars: {
          autoplay: 0,
        },
        events: {
          onReady: (e) => {
            setVideoLoading(false);
          },
          onPlayerReady: (e) => {
            console.log(e);
          },
          onStateChange: (e) => {
            console.log("State Change", e);
            if (e.data === 0) {
              videoCompleted();
            }
          },
        },
      });
      console.log(players);
    } catch (error) {
      console.log(error);
    }
  };

  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const videoCompleted = () => {
    let videoData = videoDetailInfo[0];
    setTimeout(() => {
      if (
        !_.isEmpty(relatedVideoList) &&
        via_lp !== "true" &&
        _.toInteger(videoData.progress) !== 100
      ) {
        setShowLearnMore(true);
      }
      dispatch(getVideoDetailListingClear());
      dispatch(getBrokerVideoDetailClear());
    }, 3000);
    let postData = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      entity_id: videoData.product_id,
      entity_type: "video",
      status: "completed",
      source: videoData.source,
      entity_name: videoData?.product_name,
      learning_points: videoData?.learning_points,
    };
    if (via_lp === "true") {
      postData.lp_id = _.toNumber(lp_id);
    }
    dispatch(
      getVideoCompt({
        module: "videoCompletionStatus",
        postData,
      })
    );

    // setIsShowCongrat(true)
    if (videoData?.progress !== 100) {
      let tempDetail = _.cloneDeep(videoDetailInfo);
      tempDetail[0].progress = 100;
      setVideoDetailInfo(tempDetail);
      // if (_.toNumber(videoData.learning_points) > 0) {
      setIsShowCongrat(true);
      // }
    }
  };

  const renderMainBody = () => {
    return (
      <>
        {_.isArray(videoDetailInfo) && videoDetailInfo?.length > 0 ? (
          videoDetailInfo.map((item, i) => {
            return (
              <>
                <div
                  className="my-credit-points videofull-view"
                  key={`video-${i}`}
                >
                  <div className="container">
                    <div className="row">
                      {/* {
                                            !isMobile ?
                                                <div className="row"
                                                >
                                                    <BackButton />
                                                </div>
                                                : ""
                                        } */}
                      {!showLearnMore ? (
                        <div className="col-md-12">
                          <div ref={textAreaRef} className="video-fullbox">
                            <div className="search__input">
                              <div className="img-box_RP">
                                <div className="tilebox"></div>

                                {(item?.source === "ecom" ||
                                  item?.source === "broker" ||
                                  item?.source === "xsel") &&
                                item?.video_type === "upload" ? (
                                  <div className="video-full">
                                    <VideoPlayer
                                      className="img-videosec learn_image-card"
                                      controls={true}
                                      // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                      src={item?.video_link}
                                      // src="https://cdn-stg.niit-mts.com/xsel/media/9cbddd10-ee5f-4972-a5da-11dfde71fcff.m3u8"
                                      width="100%"
                                      height="65vh"
                                      autoPictureInPicture={true}
                                      poster={
                                        !showLearnMore
                                          ? item?.product_thumbnail
                                          : ""
                                      }
                                      fluid={true}
                                      inline={false}
                                      pictureInPictureToggle={true}
                                      type={item?.extension}
                                      onReady={onPlayerReady}
                                      crossorigin="use-credentials"
                                    />
                                  </div>
                                ) : (item?.source === "ecom" ||
                                    item?.source === "xsel" ||
                                    item?.source === "broker") &&
                                  item?.video_type === "embed" ? (
                                  <div
                                    className="video-full"
                                    id="player"
                                    dangerouslySetInnerHTML={{
                                      __html: item.video_link,
                                    }}
                                  ></div>
                                ) : item.is_videofile ? (
                                  item.is_youtube ? (
                                    <div className="video-full">
                                      {videoLoading && (
                                        <div className="container">
                                          <ShimmerScreen
                                            case="rect"
                                            width="100%"
                                            height="65vh"
                                            borderRadius="10px"
                                          />
                                        </div>
                                      )}
                                      <div
                                        className=""
                                        style={{
                                          visibility: videoLoading
                                            ? "hidden"
                                            : "visible",
                                          height: videoLoading
                                            ? "0px"
                                            : "unset",
                                        }}
                                      >
                                        <div id="youtube-player"></div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="video-full">
                                      <VideoPlayer
                                        className="img-videosec learn_image-card"
                                        controls={true}
                                        // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                        // src="https://cdn-stg.niit-mts.com/xsel/media/9cbddd10-ee5f-4972-a5da-11dfde71fcff.m3u8"
                                        src={item?.video_link}
                                        width="100%"
                                        height="65vh"
                                        autoPictureInPicture={true}
                                        poster={
                                          !showLearnMore
                                            ? item?.product_thumbnail
                                            : ""
                                        }
                                        fluid={true}
                                        inline={false}
                                        pictureInPictureToggle={true}
                                        type={item?.extension}
                                        onReady={onPlayerReady}
                                        crossorigin="use-credentials"
                                      />
                                    </div>
                                  )
                                ) : (
                                  <div className="video-full">
                                    {videoLoading && (
                                      <ShimmerScreen
                                        case="rect"
                                        width="100%"
                                        height="65vh"
                                        borderRadius="10px"
                                      />
                                    )}
                                    <div
                                      className=""
                                      style={{
                                        visibility: videoLoading
                                          ? "hidden"
                                          : "visible",
                                        height: videoLoading ? "0px" : "unset",
                                      }}
                                    >
                                      <iframe
                                        className="w-1000"
                                        id="scorm_player"
                                        height={"65vh"}
                                        title={"video_player"}
                                        style={{
                                          minHeight: "65vh",
                                          width: "100%",
                                          margin: "0 auto",
                                          display: videoLoading
                                            ? "none"
                                            : "block",
                                        }}
                                        frameBorder="0"
                                        marginHeight="0"
                                        marginWidth="0"
                                        src={item?.video_link.replace("\\", "")}
                                        allowFullScreen={true}
                                        // onLoad={() => floaded()}
                                        onLoad={() => setVideoLoading(false)}
                                      />
                                    </div>
                                    <div id="scorm_player"></div>
                                  </div>
                                )}
                                {/* <div className="details-card_RP video-desc">
                                                                    <div className="row info-bottm-card_nw">
                                                                        <div className="col-md-12 ">
                                                                            <p
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: item?.product_description,
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : showLPLearnMore && via_lp === "true" ? (
                        <div className="container sec-II mt-4">
                          <div class="row ">
                            <LPdetailComp
                              contentList={learningPathData?.coursesList}
                              lpDetail={learningPathData}
                              showShimmer={showShimmer}
                              is_learn_more={true}
                              fromPage={"lp"}
                              isMobile={isMobile}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="row videolistbox">
                          <div className="col-md-12">
                            <VideoContentSection
                              relatedVideoList={relatedVideoList}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {isShowCongrat ? ( //isShowCongrat
                    <>
                      <CongPopupAnimation
                        title={videoDetailInfo[0]?.product_name}
                        lpPoints={_.toNumber(
                          videoDetailInfo[0].learning_points
                        )}
                        fromPage={isLPCompleted ? 2 : 0}
                        name={"video"}
                        setIsAnimCompleted={setIsAnimCompleted}
                      />
                    </>
                  ) : (
                    ""
                  )}

                  {showLearnMore ? (
                    ""
                  ) : (
                    <AssignCourseModal
                      show={show}
                      parentName={"Video"}
                      parentId={
                        source === "xsel" && videoDetailInfo?.length > 0
                          ? videoDetailInfo[0].course_code
                          : productId
                      }
                      setShow={setShow}
                      origin={
                        source === "xsel" || source === "ecom"
                          ? "xsel"
                          : "broker"
                      }
                      isMobile={false}
                    />
                  )}
                </div>
              </>
            );
          })
        ) : isLoading ? (
          <div className="my-credit-points videofull-view">
            <div className="container">
              <ShimmerScreen
                case="rect"
                width="100%"
                height="65vh"
                borderRadius="10px"
              />
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="row">
              <div className="not-found mt-3">
                <div className="interboxes">
                  {/* <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" /> */}
                  <NotFoundImage />
                  <p>No video data found.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {/* <Loader start={isLoading} /> */}

      {isLoading ? (
        <div className="my-credit-points videofull-view">
          <div className="container">
            <ShimmerScreen
              case="rect"
              width="100%"
              height="65vh"
              borderRadius="10px"
            />
          </div>
        </div>
      ) : _.isEmpty(headerProdData) ? (
        ""
      ) : !headerProdData?.priceInfo.isFree ? (
        <DetailPageBannerHeaderComponent
          bannerURL={""}
          btnName={t("Purchase to unlock")}
          productData={headerProdData}
          showTagLine={!_.isEmpty(headerProdData.priceInfo.showText)}
          showShareIcon={true}
          showCartBtn={isLoggedIn ? true : headerProdData.price > 0}
          tagLine={`${headerProdData.priceInfo.showText}`}
          rightTagLine={`${
            headerProdData.purchaseInfo.offer_ends_on_text
              ? headerProdData.purchaseInfo.offer_ends_on_text
              : ""
          }`}
          setIsMainPageLoading={setIsMainPageLoading}
          hasTeaser={hasTeaser}
          isMobile={isMobile}
          entityType={"video"}
        />
      ) : (
        renderMainBody()
      )}
      {!showLearnMore && (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <BreadCrumbComponent crumbList={breadCrumbData} />
              <VideoDetailComponent videoData={videoInfo} isMobile={isMobile} />
            </div>
          </div>
        </div>
      )}
      {showRankUp && (
        <AfterCongratulationsModal
          show={showRankUp}
          setShow={setShowRankUp}
          rank={newRank}
          isMobile={isMobile}
        />
      )}
    </>
  );
};

export default VideoViewPageSection;
